// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__vGvyJ","loader":"Loader_loader__M-nsl"};